// @flow
import * as React from 'react'
import useStyles from './styles'
import {
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@material-ui/core'
declare type Props = {
  values: LoginValues,
  touched: LoginTouched,
  errors: LoginErrors,
  handleFieldChange: (string, string) => void,
  handleSignIn: (Object) => Promise<void>,
  isLoading: boolean,
  isValid: boolean,
  submitError: Error | null,
}
const LoginForm = ({
  values,
  touched,
  errors,
  handleFieldChange,
  handleSignIn,
  isLoading,
  isValid,
  submitError,
}: Props) => {
  const classes = useStyles()

  return (
    <form className={classes.form} onSubmit={handleSignIn}>
      <img
        alt="CP Mobile"
        className={classes.logoImage}
        src="/images/logos/CP.png"
      />
      <Typography className={classes.title} gutterBottom variant="h2">
        Sign In
      </Typography>
      <Typography variant="body2">
        Enter your email (case sensitive) and password below to sign in.
      </Typography>

      <div className={classes.fields}>
        <TextField
          id="sign-in-email"
          fullWidth
          className={classes.textField}
          label="Email Address"
          name="email"
          onChange={(event) => handleFieldChange('email', event.target.value)}
          type="text"
          value={values.email}
          variant="outlined"
        />
        {touched.email && errors.email && errors.email.length && (
          <Typography className={classes.fieldError} variant="body2">
            {errors.email[0]}
          </Typography>
        )}
        <TextField
          id="sign-in-new-password"
          fullWidth
          className={classes.textField}
          label="Password"
          name="password"
          onChange={(event) =>
            handleFieldChange('password', event.target.value)
          }
          type="password"
          value={values.password}
          variant="outlined"
        />
        {touched.password && errors.password && errors.password.length && (
          <Typography className={classes.fieldError} variant="body2">
            {errors.password[0]}
          </Typography>
        )}
      </div>
      {submitError && (
        <Typography className={classes.submitError} variant="body2">
          {submitError.message}
        </Typography>
      )}
      {
        <Button
          type="submit"
          className={classes.signInButton}
          color="primary"
          disabled={!isValid || isLoading}
          size="large"
          variant="contained"
        >
          {isLoading ? (
            <CircularProgress size={25} className={classes.progress} />
          ) : (
            'Sign In'
          )}
        </Button>
      }
    </form>
  )
}

export default LoginForm
